import CONSTANTS from '../../../config/constants';
import { getStore } from '../../../stores/StoreContext';
import BaseOverlay from './BaseOverlay';

const SessionEnded = ({ lastConnectionChange, size = 'large', iconSize = 'large', titleVariant = 'h2', padding = 'large', showExpandedInfo = true }) => {
  const AppStore = getStore('appStore');

  const extractData = (lastConnectionChange) => {
    return {
      title: "Session Ended",
      subtitle: lastConnectionChange?.metadata?.reasonText || null,
      buttonText: "Ok",
      iconName: "IconCheckDarkLine",
      note: lastConnectionChange?.metadata?.notes || null,
      alertTitle: "Note",
      alertVariant: "info",
      iconColor: "success"
    };
  };

  const handleAcknowledgement = async () => {
    await AppStore.reinitialize();
  };

  return (
    <BaseOverlay
      lastConnectionChange={lastConnectionChange}
      size={size}
      iconSize={iconSize}
      titleVariant={titleVariant}
      padding={padding}
      showExpandedInfo={showExpandedInfo}
      ttlConstant={CONSTANTS.OVERLAYS.SESSION.ENDED.TTL}
      onDataExtract={extractData}
    //onAcknowledgement={handleAcknowledgement}
    />
  );
};

export default SessionEnded;
